import React from 'react';
import { siteContent } from '../content/siteContent';

const Pricing = () => {
  const { pricing } = siteContent;

  return (
    <section id="pricing" className="pricing" aria-labelledby="pricing-heading">
      <div className="container">
        <div className="pricing-summary">
          <h2 id="pricing-heading">{pricing.heading}</h2>
          <p>{pricing.message}</p>
        </div>

        <div className="pricing-cards card-grid" role="list" aria-label="Lesson format pricing">
          {pricing.options.map((option) => (
            <article key={option.title} className="pricing-card surface-card" role="listitem">
              <p className="pricing-card__label">{option.label}</p>
              <h3>{option.title}</h3>
              <p className="price" aria-label={`${option.title} ${option.price}${option.suffix}`}>
                {option.price}
                <span>{option.suffix}</span>
              </p>
              <p className="pricing-card__description">{option.description}</p>
            </article>
          ))}
        </div>

        <div className="pricing-actions">
          <p className="pricing-cta-copy">{pricing.ctaCopy}</p>
          <a href="#contact" className="btn btn--primary pricing-cta">{pricing.ctaLabel}</a>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
